import { render, staticRenderFns } from "./PosIdPagination.vue?vue&type=template&id=b540e2bc&scoped=true&"
import script from "./PosIdPagination.vue?vue&type=script&lang=js&"
export * from "./PosIdPagination.vue?vue&type=script&lang=js&"
import style0 from "./PosIdPagination.vue?vue&type=style&index=0&id=b540e2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b540e2bc",
  null
  
)

export default component.exports